module.exports = __webpack_public_path__ + "static/media/camera-green-small.dad87598.svg";